export default "__VITE_ASSET__CdSYBsi4__"